import { Dispatch } from "@reduxjs/toolkit";
import { setNotification } from "./reducer";

export const notificationActionDispatch = (dispatch: Dispatch) => ({
  setNotification: (notification: any) =>
    dispatch(setNotification(notification)),
});
